//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeadBar from './component/bar/headBar';
import FootBar from './component/bar/footBar';
import { mapGetters } from 'vuex';
import nativeAdapter from '../js/nativeAdapter/nativeAdapter';

export default {
    name: 'app',
    components: { HeadBar, FootBar },
    data() {
        return {
            tabs: null,
            isCn: this.$x.userInfo.lgid === 2052,
            isKayangIos: nativeAdapter.isKayang && nativeAdapter.isIos, //是否嘉扬ios的app
            isIosX: nativeAdapter.isIosX,
            isAndroid: nativeAdapter.isAndroid
        }
    },
    created() {
    },
    methods: {},
    watch: {
        routerTabs(n, o) {
            this.tabs = n;
            if (!n.length) {
                this.$router.replace('/errorMsg')
            }
        },
        '$route.path'() {
            const body = this.$x('body')[0];
            if (this.$route.meta.setFullScreen) {
                const bodyWidth = body.offsetWidth;
                const bodyHeight = body.offsetHeight;
                body.style.width = bodyHeight + 'px';
                body.style.height = bodyWidth + 'px';
                body.style.top = (bodyHeight - bodyWidth) / 2 + 'px';
                body.style.left = -(bodyHeight - bodyWidth) / 2 + 'px';
                body.className = 'fullScreen';
            } else {
                body.className = '';
                body.style = '';
            }
        },
    },
    computed: {
        ...mapGetters(['routerTabs', 'canGoBack']),
        showBar() {
            let showHead = false;
            let showFoot = false;
            const path = this.$route.path;
            // 先判断加载前路由，否则页面会闪动且高度计算会出现错误
            const defaultRouter = path === '/' && !this.$route.meta.title;
            if (!defaultRouter) {
                // 特殊路由
                // 排班管理从首页进入aspx选择参数进入aspx页, 其中嵌套了vue
                const specialRouter = path === '/arrangeWork';

                showHead = !this.$route.meta.hideBarHead;
                showFoot = (!this.$route.meta.hideBarFoot || !this.canGoBack) && !specialRouter;
            }
            return {
                head: showHead,
                foot: showFoot && this.tabs.length > 1,
            }
        },
    }
}
